import React from "react";
import styled from "styled-components";
import Result from "./result";

const ResultsContainer = styled.div``;

// const Results = ({ results }) => {
//   return <ResultsContainer>{
//     results.map(result => <Result result={result} />)}
//
//  <ResultsContainer>
//

const id = Math.random();

const Results = ({ results }) => (
  <ResultsContainer>
    {results.map((result, i) => (
      <Result key={`result-${id}-${i}`} result={result} />
    ))}
  </ResultsContainer>
);

export default Results;
